import { produce } from 'immer'
import { create } from 'zustand'
import { TermoAceito, TermoPendente, TermosStore, TermosStoreState } from './types'

const INITIAL_STATE: TermosStoreState = {
    data: {
        termosAceitos: [],
        termosPendentes: [],
    }
}

export const useTermosStore = create<TermosStore>()(
  (set, get) => {
    const setState = (fn: any) => set(produce<TermosStore>(fn))
    return {
      state: INITIAL_STATE,
      actions: {
        alteraTermosAceitos: (termosAceitos: TermoAceito[]) => {
          setState((state: TermosStore)=>{
            state.state.data.termosAceitos = termosAceitos;
          })
        },
        alteraTermosPendentes: (termosPendentes: TermoPendente[]) => {
          setState((state: TermosStore)=>{
            state.state.data.termosPendentes = termosPendentes;
          })
        },
        limpaTermosPendentes: () => {
          setState((state: TermosStore)=>{
            state.state.data.termosPendentes = [];
          })
        },
        limpaTermosAceitos: () => {
          setState((state: TermosStore)=>{
            state.state.data.termosAceitos = [];
          })
        },
      },
    }
  },
)